/**
 * Страница менеджера: список запросов проектов (manager/projectsrequests).
 *
 * Маркер инициализации — таблица #requests-table.
 *
 * Функционал:
 *   - debounced поиск + фильтр по статусу расчёта;
 *   - управление видимостью пагинации и "нет результатов".
 */

function init() {
    if (!document.getElementById('requests-table')) return;

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-projects-requests] jQuery not loaded');
        return;
    }

    $(() => {
        let searchTimeout;

        function filterTable() {
            const searchValue = $('#adm_search_input').val().toLowerCase().trim();
            const selectedStatuses = [];

            $('.filter-checkbox:checked').each(function () {
                selectedStatuses.push($(this).val());
            });

            let visibleRows = 0;

            $('#requests-table tbody tr').each(function () {
                const row = $(this);
                const status = String(row.data('status') || '').trim();
                const rowText = row.text().toLowerCase();

                const searchMatch = searchValue === '' || rowText.includes(searchValue);
                const statusMatch = selectedStatuses.length === 0 || selectedStatuses.includes(status);

                if (searchMatch && statusMatch) {
                    row.show();
                    visibleRows++;
                } else {
                    row.hide();
                }
            });

            if (visibleRows === 0) {
                $('#no-results').show();
                $('.pagination').hide();
            } else {
                $('#no-results').hide();
                if (searchValue === '' && selectedStatuses.length === 0) {
                    $('.pagination').show();
                } else {
                    $('.pagination').hide();
                }
            }
        }

        $('#adm_search_input').on('input keyup', function () {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(filterTable, 300);
        });

        $(document).on('change', '.filter-checkbox', filterTable);

        $('.adm_search_button').on('click', function (e) {
            e.preventDefault();
            filterTable();
        });

        $('#adm_search_input').on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                filterTable();
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
